<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/uvCBJv/d2d_images/cover.jpg?1670934262854" alt="This image is the cover for the book Antologia"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Antologia
      </h1>
      <p class="bookDescription body article font2">
        <p>15 racconti erotici<br/> Racconto 1………………………..………………..………..…………… Ammanettala<br/> Racconto 2………………………..………………..………..…………… Serata in famiglia 2<br/> Racconto 3………………………………..………………..…………….. I bikini sono pericolosi 4<br/> Racconto 4……………………………………..…………..…………….. I bikini sono pericolosi 5<br/> Racconto 5………………………………………..………..…………….. Sognatrici su internet<br/> Racconto 6……………………………………………..…..…………….. Sbaciucchiata<br/> Racconto 7…………………………………………………..…………… La cercatrice di pietre preziose<br/> Racconto 8……..…………………………………………..…………….. Rubate<br/> Racconto 9…………..……………………………………..…………….. Scossa<br/> Racconto 10……………..……………………………………..…………. La ladra affascinante ~L'Isola dei Serpenti~<br/> Racconto 11…………………..……………………………..……………. L'amore della mia vita<br/> Racconto 12……………………..……………………………..…………. Sveltina in ascensore, scendendo?<br/> Racconto 13……………………………..…………………..……………. Nel giardino<br/> Racconto 14…………………………..……………………..……………. Un ménage à quante?<br/> Racconto 15…………………………………..………………..…………. Una storia da dimenticare<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        K'Anne Meinel, ...
      </h2>
      
      <p class="authorDescription body article">K’Anne Meinel è l’autrice dei best seller <i>Lawyered</i>, <i>Represented</i> e <i>Sapphic Surfer</i> così come di molti altri, incluso il suo primo libro <i>Ships</i>, scritto nel 2003 in tre settimane. Ci ha giocato per anni prima di pubblicarlo come e-book e poi le fu chiesto di pubblicarlo come libro stampato. Dopo di che ha pubblicato e-book su altri siti. Nel frattempo ha pubblicato qualcosa come 50 novelle, romanzi brevi e romanzi di vario genere.<br/> Originaria del Wisconsin, molte delle sue storie si svolgono o cominciano da quello stato. Una gitana nel cuore, ha vissuto in molte località e progetta di continuare a farlo. I video dei suoi diversi libri sono disponibili su youtube e mostrano alcune delle ambientazioni dei suoi libri e raccontando qualcosa in più… dando ai lettori uno sguardo all’interno della sua mente quando ha creato queste storie meravigliose.<br/></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Shadoe Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c8646078